import ActionButton from '../../../../components/form/ActionButton/ActionButton';
import FaIcon, { faTriangleExclamation } from '../../../../components/icon/FaIcon/FaIcon';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import styles from './WChancePendingCount.module.scss';

type WChancePendingCountProps = {
  pendingCount: number;
  handleDrawLots: () => void;
  isLoading: boolean;
  headerText?: string;
  annotationText?: string;
  wChanceType?: string;
};

function WChancePendingCount({
  pendingCount,
  handleDrawLots,
  isLoading,
  headerText = '今回受付分の抽選待ち回数',
  annotationText = 'Wチャンス賞の抽選予定日時はイベント詳細をご確認ください',
  wChanceType,
}: WChancePendingCountProps) {
  return (
    <div className={styles.componentStyle}>
      <div className={styles.countWrapper}>
        <div className={styles.header}>
          {wChanceType === 'direct' ? 'Wチャンス賞チャレンジ可能回数' : `${headerText}`}
        </div>
        <div className={`${utilsStyles.mtSmall} ${styles.waitingCount}`}>
          {pendingCount}
          <span>回</span>
        </div>
        {wChanceType === 'batch' && (
          <p className={`${utilsStyles.mtSmall} ${styles.annotation} ${utilsStyles.textCenter}`}>{annotationText}</p>
        )}
        {wChanceType === 'direct' && (
          <div className={`${utilsStyles.mtSmall} ${utilsStyles.centeredVertical} `}>
            <p
              className={`${utilsStyles.mtSmall} ${utilsStyles.primaryColor} ${utilsStyles.textBold} ${utilsStyles.textCenter}`}
            >
              <FaIcon icon={faTriangleExclamation} size={'lg'} />
              &nbsp; 下記ボタンを押すと抽選が開始いたします
            </p>
            <br />
            <ActionButton
              size={'large'}
              color={'primary'}
              onClick={handleDrawLots}
              disabled={isLoading}
              isLoading={isLoading}
            >
              Wチャンス賞にチャレンジする
            </ActionButton>
          </div>
        )}
      </div>
    </div>
  );
}

export default WChancePendingCount;
